module.exports = __webpack_public_path__ + "media/images/gameLogo--fr-9c53e04c0ecdbc52e0a477a2973fce85.png";